import { render } from "./HostVhbaDevicesTransfer.vue?vue&type=template&id=845faf9c&scoped=true"
import script from "./HostVhbaDevicesTransfer.vue?vue&type=script&lang=js"
export * from "./HostVhbaDevicesTransfer.vue?vue&type=script&lang=js"

import "./HostVhbaDevicesTransfer.vue?vue&type=style&index=0&id=845faf9c&lang=scss&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-845faf9c"]])

export default __exports__